export const API_URL = process.env.REACT_APP_API_URL;
export const JWT_SECRET = 'fi8bfk3ikfuk3urf93uf3uh3fuh';
export const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
export const STRIPE_CLIENT_SECRET = process.env.REACT_APP_STRIPE_CLIENT_SECRET;
